import React from 'react';

import LoginForm from 'components/Auth/LoginForm';
import BannerModal from 'components/PopupBanner';

import { callApi } from 'util/call-api';
import { catchError, isEmpty } from 'util/utils';

import { GET_BANNERS } from 'constants/apiConstant';

function SignIn() {
  const [visible, setVisible] = React.useState(false);
  const [activeBanners, setActiveBanners] = React.useState([]);

  const getLandingPageNewsData = React.useCallback(async () => {
    const [, res] = await callApi({
      ...GET_BANNERS,
      request: { page: 1, limit: 100, filter: { bannerType: 1 } },
    });

    catchError(() => {
      const activeList = res.data.list?.filter((item) => item?.isActive) ?? [];
      setActiveBanners(activeList);
      const hasType24 = activeList.some((item) => item?.type === '24');
      setVisible(hasType24);
    });
  }, [setVisible]);

  const bannerList = React.useMemo(() => {
    return activeBanners
      .filter((item) => item?.type === '24')
      .map((item) => item?.images ?? [])
      .flat();
  }, [activeBanners]);

  React.useEffect(() => {
    getLandingPageNewsData();
  }, [getLandingPageNewsData]);

  return (
    <div className="loginMainWrapper" style={{ display: 'block' }}>
      <BannerModal visible={visible} onClose={() => setVisible(false)} bannerList={bannerList} />
      <LoginForm activeBanners={activeBanners} />
    </div>
  );
}

export default SignIn;
